import DynamicTable from "components/ui/TableComponents/DynamicTable";
import React, { useContext, useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { ReactComponent as EditIcon } from "assets/icons/CatalogueCard/edit.svg";
import { useGlobalContext } from "context/GlobalContext";
import { SettingContext } from "context/SettingContext";
import EditLimitsModal from "components/ui/EditLimitModal/EditLimitModal";
import { useClientLimits, useUpdateClientLimit, useUpdateUserLimit, useUserLimits } from "./api/limitsApis";
import SortContext from "context/SortContext";
import { toast } from "react-toastify";


const EditButton = ({ onClick }) => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <div
      onClick={onClick}
      style={{
        width: "40px",
        height: "28px",
        border: "1px solid #fff",
        borderRadius: "6px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        // margin: "0px 65px",
      }}
    >
      <EditIcon width={16} height={16} />
    </div>
  </div>
);

const LimitsSubPage = () => {
  const { limitType } = useParams();
  const location = useLocation();
  const { selectedSortValue } = React.useContext(SortContext);
  const { setSearch, setSearchBar, search } = useContext(SettingContext);
  const { setSortOptions, setSortValue, setDynamicFilterCount, setSearchPlaceHolder, dynamicfilterCount, filterChangeCount, setDisplayCount, setSearchResultCount, setFilterChangeCount, sortOptions } =
    useGlobalContext();

  const [openModal, setOpenModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const [createLimit, setCreateLimit] = useState("");
  const [sendLimit, setSendLimit] = useState("");
  const [hourLimit, setHourLimit] = useState("");
  const [selectedUserId, setSelectedUserId] = useState(null);

  const { mutateAsync: updateLimit } = useUpdateUserLimit();
  const { mutateAsync: updateClientLimit } = useUpdateClientLimit();

  const [selectedName, setSelectedName] = React.useState("");

  const isRole = limitType === "limitUser";

  const handleOpenModal = (row) => {
    setSelectedRow(row);
    setSelectedUserId(row._id);
    setSelectedName(isRole ? row.userName : row.clientName);

    if (isRole) {
      setCreateLimit(row.createCatalogLimit);
      setSendLimit(row.sendCatalogLimit);
      setHourLimit(row.hourLimit);
    } else {
      setSendLimit(row.sendCatalogLimit);
    }

    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const selectedOption = React.useMemo(() => {
    return sortOptions.find((option) => option.id == selectedSortValue);
  }, [sortOptions, selectedSortValue]);

  const selectedSortBY = selectedOption?.sortBy;
  const selectedSortOrder = selectedOption?.order;

  // console.log("selectedSortBY===>>",selectedSortBY,"selectedSortOrder===>>",selectedSortOrder)

  const {
    data: AllUserLimit,
    isLoading,
    isError,
  } = useUserLimits({
    isRole,
    search,
    sortBy: selectedSortBY,
    order: selectedSortOrder,
  });

  //Role by Client

  const {
    data: AllClientLimit,
    isLoading: isClientLoading,
    isError: isClientError,
  } = useClientLimits({
    isRole,
    search,
    sortBy: selectedSortBY,
    order: selectedSortOrder,
  });

  const data = isRole ? AllUserLimit : AllClientLimit;

  const headers = isRole
    ? [
        { label: "User name", className: "default" },
        {
          label: "Create Catalog Limit",
          className: "default",
          tooltip: "What is the maximum number of designs that can be added to a catalog?",
        },
        {
          label: "Send Catalog Limit",
          className: "default",
          tooltip: "What is the maximum catalog size this user can share?",
        },
        {
          label: "Hour Limit",
          className: "default",
          tooltip: "How long can the client have maximum access to the catalog?",
        },
        { label: "Edit", className: "narrow" },
      ]
    : [
        { label: "Client name", className: "default" },
        {
          label: "Send Catalog Limit",
          className: "default",
          tooltip: "What is the maximum catalog size this client can share?",
        },
        { label: "Edit", className: "narrow" },
      ];

  const rows = data?.map((item) => {
    if (isRole) {
      return [item.userName, item.createCatalogLimit, item.sendCatalogLimit, item.hourLimit, <EditButton onClick={() => handleOpenModal(item)} />];
    }

    return [item.clientName, item.sendCatalogLimit, <EditButton onClick={() => handleOpenModal(item)} />];
  });

  const sections = [{ headers, rows }];

  useEffect(() => {
    if (isRole) {
      setSortOptions([
        { id: 1, name: "User Name (A to Z)", sortBy: "userName", order: "asc" },
        { id: 2, name: "User Name (Z to A)", sortBy: "userName", order: "desc" },
        { id: 3, name: "Create Catalog Limit (Low to High)", sortBy: "createCatalogLimit", order: "asc" },
        { id: 4, name: "Create Catalog Limit (High to Low)", sortBy: "createCatalogLimit", order: "desc" },
        { id: 5, name: "Send Catalog Limit (Low to High)", sortBy: "sendCatalogLimit", order: "asc" },
        { id: 6, name: "Send Catalog Limit (High to Low)", sortBy: "sendCatalogLimit", order: "desc" },
        { id: 7, name: "Hour Limit (Low to High)", sortBy: "hourLimit", order: "asc" },
        { id: 8, name: "Hour Limit (High to Low)", sortBy: "hourLimit", order: "desc" },
      ]);
    } else {
      setSortOptions([
        { id: 1, name: "Client Name (A to Z)", sortBy: "Client Name", order: "asc" },
        { id: 2, name: "Client Name (Z to A)", sortBy: "Client Name", order: "desc" },
        { id: 3, name: "Send Catalog Limit (Low to High)", sortBy: "Design Limit", order: "asc" },
        { id: 4, name: "Send Catalog Limit (High to Low)", sortBy: "Design Limit", order: "desc" },
        // { id: 5, name: "Hour Limit (Oldest to Newest)", sortBy: "Hour Limit", order: "asc" },
        // { id: 6, name: "Hour Limit (Newest to Oldest)", sortBy: "Hour Limit", order: "desc" },
      ]);
    }

    setSearchBar(true);
    isRole ? setSearchPlaceHolder("Search By User Name") : setSearchPlaceHolder("Search By Client Name");
    return () => {
      setSearch("");
      setSearchBar(false);
      setSortOptions([]);
      setSortValue(null);
      setSearchPlaceHolder("");
      setDynamicFilterCount(true);
    };
  }, []);

  useEffect(() => {
    setSearch("");
  }, [location]);

  useEffect(() => {
    if (search === "") {
      setDynamicFilterCount(true);
    }

    if (dynamicfilterCount) {
      setSearchResultCount(data?.length);
      setFilterChangeCount(data?.length);
    } else {
      setSearchResultCount(data?.length);
      setFilterChangeCount(filterChangeCount);
    }
    setDisplayCount(true);

    return () => {
      setSearchResultCount(0);
      setFilterChangeCount(0);
      setDisplayCount(false);
    };
  }, [data]);

  return (
    <>
      <DynamicTable sections={sections} loading={isLoading || isClientLoading} maxHeight={"75vh"} />
      <EditLimitsModal
        open={openModal}
        handleClose={handleCloseModal}
        createLimit={createLimit}
        setCreateLimit={setCreateLimit}
        sendLimit={sendLimit}
        setSendLimit={setSendLimit}
        hourLimit={hourLimit}
        setHourLimit={setHourLimit}
        onSave={async () => {
          try {
            if (isRole) {
              await updateLimit({
                userId: selectedUserId,
                createCatalogLimit: Number(createLimit),
                sendCatalogLimit: Number(sendLimit),
                hourLimit: Number(hourLimit),
              });
      
              toast.success(
                `Limits for user ${selectedName} have been updated successfully.`
              );
            } else {
              await updateClientLimit({
                clientId: selectedUserId,
                sendCatalogLimit: Number(sendLimit),
              });
      
              toast.success(
                `Limits for client ${selectedName} have been updated successfully.`
              );
            }
      
            setOpenModal(false);
          } catch (error) {
            const errorMessage =
              error?.response?.data?.message || "Something went wrong";

            toast.error(errorMessage);
          }
        }}
        isRole={isRole}
      />
    </>
  );
};

export default LimitsSubPage;
